export const myAccountApiPaths = {
    takeOverOrganisation: 'transfers/takeOverOrganisation',
    price: 'pricing/calculate',
    activateTrialOfAllFeatures: 'organisations/activateTrialOfAllFeatures',
};
